// ***********************************************************
// pathname: /v1/user/phone-number
// ***********************************************************
import { useSwrApi } from '@hooks/useSwrApi';

/** Props */
type ApiResponse = ApiSchema<'PhoneNumberWriteDataObject'>;
interface SwrUserPhoneNumberProps {
  locale: string;
  shouldFetch?: boolean;
  successCallback?: (response?: ApiResponse) => void;
}

/**
 * @description This hook is used for fetching the user's phone number.
 * - `locale` is the language locale
 * - `shouldFetch` is a boolean that indicates if the request should be made
 */
export const useSwrUserPhoneNumber = (props: SwrUserPhoneNumberProps) => {
  // Destructure props
  const {
    locale,
    shouldFetch = true,
    successCallback,
  } = props;

  // Return hook
  return useSwrApi<ApiResponse>({
    url: '/v1/user/phone-number',
    locale,
    shouldFetch,
    apiOptions: {
      revalidateOnFocus: false,
      dedupingInterval: 1000 * 10, // 10 seconds
      onSuccess: (response) => {
        if (successCallback) successCallback(response);
      },
    },
  });
};
